import {
  SpendBudget,
  SpendSeason,
  SpendTransactionFix,
} from "graphql/generated";
import { FormatMoney } from "helpers/format-money";
import useModal from "hooks/use-modal";
import { useEffect, useState } from "react";
import { SnapButton, SnapSelectMenu } from "suit";
import Step4AddBudgetItem from "./step-4-add-budget-item";

type Step4SeasonSelectProps = {
  selectedTransaction?: SpendTransactionFix;
  seasons: SpendSeason[];
  selectedSeason?: { id: string; name: string };
  setSelectedSeason?: React.Dispatch<
    React.SetStateAction<{ id: string; name: string } | undefined>
  >;
  selectedBudgetItem?: SpendBudget;
  setSelectedBudgetItem: React.Dispatch<
    React.SetStateAction<SpendBudget | undefined>
  >;
};

function Step4Fixes({
  selectedTransaction,
  seasons,
  selectedSeason,
  setSelectedSeason,
  selectedBudgetItem,
  setSelectedBudgetItem,
}: Step4SeasonSelectProps) {
  const [budgets, setBudgets] = useState<SpendBudget[]>([]);
  const { isOpen: isAddBudgetItemOpen, toggle: toggleAddBudgetItem } =
    useModal();
  useEffect(() => {
    if (selectedSeason?.id) {
      const foundSeason = seasons.find((s) => s.id === selectedSeason.id);
      setBudgets(foundSeason?.budgets as SpendBudget[]);
    }
    // eslint-disable-next-line
  }, [selectedSeason?.id, seasons]);

  return (
    <>
      {isAddBudgetItemOpen && selectedSeason?.id ? (
        <Step4AddBudgetItem
          selectedSeasonId={selectedSeason?.id}
          selectedTransaction={selectedTransaction}
          toggleAddBudgetItem={toggleAddBudgetItem}
        />
      ) : (
        <>
          <p className="font-bold">
            Description:{" "}
            <span className="font-normal">
              {selectedTransaction?.description}
            </span>
          </p>
          <p className="font-bold">
            Amount:{" "}
            <span className="font-normal">
              {FormatMoney(selectedTransaction?.amount)}
            </span>
          </p>
          <p className="font-bold">
            Date:{" "}
            <span className="font-normal">{selectedTransaction?.date}</span>
          </p>
          <p className="font-bold">
            Type:{" "}
            <span className="font-normal">
              {selectedTransaction?.transactionType}
            </span>
          </p>
          <div className="mt-5">
            <p>Select a season</p>
            <SnapSelectMenu
              selectMenuOptions={seasons.map((s) => ({
                name: s.name!,
                value: s.id!,
                selected: selectedSeason?.id === s.id,
              }))}
              onSnap-select-menu-updated={(e) => {
                const selectedItem = e.detail.find((s) => s.selected);
                if (selectedItem && setSelectedSeason) {
                  setSelectedSeason({
                    id: selectedItem.value!,
                    name: selectedItem.name,
                  });
                }
              }}
            />
          </div>
          {selectedSeason?.id && (
            <>
              <div className="mt-5">
                <p>Select or add a budget item</p>
                <div className="grid grid-cols-2">
                  <SnapSelectMenu
                    className="w-full"
                    selectMenuOptions={budgets.map((b) => ({
                      name: b.description,
                      value: b.id,
                      selected: selectedBudgetItem?.id === b.id,
                    }))}
                    onSnap-select-menu-updated={(e) => {
                      const selectedItem = e.detail.find((d) => d.selected);
                      const foundBudgetItem = budgets.find(
                        (b) => b.id === selectedItem?.value
                      );
                      if (foundBudgetItem) {
                        setSelectedBudgetItem(foundBudgetItem);
                      }
                    }}
                  />
                  <SnapButton
                    variant="primary"
                    className="ml-auto"
                    onClick={toggleAddBudgetItem}
                  >
                    Add Budget Item
                  </SnapButton>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}

export default Step4Fixes;
